// Centralized constants for the application

// Social links
export const DISCORD_INVITE_URL = 'https://discord.gg/TttzEZdmrW'

// External links
export const STEAM_WORKSHOP_URL = 'https://steamcommunity.com/sharedfiles/filedetails/?id=2187784730'
export const CURSEFORGE_URL = 'https://www.curseforge.com/ark-survival-ascended/mods/chaos-creator'

// Twitch limits
export const TWITCH_MAX_REWARDS = 50
